import { hubbleEntryEvent } from '@/common/js/track';
import Vue from "vue";
import Router from "vue-router";
import { getUser } from '@/api/user';

Vue.use(Router);

const isOnline = process.env.VUE_APP_MODE === 'online';

const router = new Router({
  mode: 'history',
  base: isOnline ? "/" : "/",
  routes: [
    {
      path: "/",
      name: "home",
      alias: ['/home', '/index'],
      component: () => import(/* webpackChunkName: "home" */ "@/pages/qzcCollegePage.vue"),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ "@/pages/ursLogin"),
    },
    {
      path: '/teacher',
      name: 'teacher',
      redirect: { name: 'paperListTeacher' },
      component: () => import(/* webpackChunkName: "teacherLayout" */ "@/pages/teacher/teacherLayout.vue"),
      meta: {
        roles: ['ADMIN', 'TEACHER'],
      },
      children: [
        {
          path: 'login',
          name: 'teacherLogin',
          meta: {
          },
          component: () => import(/* webpackChunkName: "login" */ "@/pages/ursLogin"),
        },
        {
          path: '',
          alias: ['paperList', 'index', 'home'],
          name: 'paperListTeacher',
          component: () => import(/* webpackChunkName: "paperListTeacher" */ "@/pages/teacher/paperList"),
        },
        {
          path: 'paperDetail',
          name: 'paperDetailTeacher',
          component: () => import(/* webpackChunkName: "paperDetailTeacher" */ "@/pages/teacher/paperDetail"),
        },
        {
          path: 'userManage',
          name: 'userManageTeacher',
          component: () => import(/* webpackChunkName: "userManage" */ "@/pages/teacher/userManagePage.vue"),
          meta: {
            roles: ['ADMIN'],
          },
        },
        {
          path: 'batchCreateAccount',
          name: 'batchCreateAccount',
          component: () => import(/* webpackChunkName: "batchCreateAccount" */ "@/pages/teacher/batchCreateAccount.vue"),
          meta: {
            roles: ['ADMIN'],
          },
        },
        {
          path:'paperCheckManage',
          name: 'paperCheckManage',
          component:() => import(/* webpackChunkName: "paperCheckManage" */ "@/pages/teacher/paperCheckManage.vue"),
          meta: {
            roles: ['ADMIN'],
          }
        },
        {
          path: 'paperInvigilationDetail',
          name: 'paperInvigilationDetail',
          component:() => import(/* webpackChunkName: "paperInvigilationDetail" */ "@/pages/teacher/paperInvigilationDetail.vue"),
        },
        {
          path: 'userInvigilationDetail',
          name: 'userInvigilationDetail',
          component:() => import(/* webpackChunkName: "userInvigilationDetail" */ "@/pages/teacher/userInvigilationDetail.vue"),

        }
      ]
    },
    {
      path: '/paperList',
      name: 'paperList',
      meta: {
        roles:['STUDENT'],
      },
      component: () => import(/* webpackChunkName: "paperList" */ "@/pages/student/paperListPage.vue"),
    },
    {
      path: '/paperDetail',
      name: 'paperDetail',
      meta: {
        roles:['STUDENT'],
      },
      component: () => import(/* webpackChunkName: "paperDetail" */ "@/pages/student/examPage.vue"),
    },
    {
      path: '/historyDetail',
      name: 'historyDetail',
      meta: {
        needLogin: true,
      },
      component: () => import(/* webpackChunkName: "paperDetail" */ "@/pages/student/historyDetailPage.vue"),
    },
    {
      path:'/contentIndex',
      name: 'contentIndex',
      meta: {
        needLogin: true,
      },
      component: () => import(/* webpackChunkName: "courseList" */ "@/pages/student/contentCenter.vue"),
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      meta: {
        needLogin: true,
      },
      component: () => import(/* webpackChunkName: "courseDetail" */ "@/pages/student/courseDetailPage.vue"),
    },
    {
      path: '/noPermission',
      name: 'noPermission',
      alias: ['/nopermission', '/error'],
      component: () => import(/* webpackChunkName: "noRight" */ "@/pages/noRight.vue"),
    },
    {
      path: '/*',
      name: 'Default',
      redirect: { name: 'home'}
    },
  ],
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 0);
    });
  }
});

router.beforeEach((to, from, next) => {
  // 设置页面标题
  // if (to?.meta?.title) {
  //   document.title = to.meta.title;
  // } else {
  //   document.title = '数学拔尖创新人才培养与测评';
  // }

  // 登录相关页面不需要权限校验
  const loginRoutes = ['login', 'teacherLogin', 'loginTest'];
  if (loginRoutes.includes(to.name)) {
    next();
    return;
  }

  // 获取最严格的权限要求
  const getStrictestRoles = (matched) => {
    // 从子路由到父路由遍历，找到第一个有权限限制的路由
    // 子路由的权限要求优先于父路由
    for (let i = matched.length - 1; i >= 0; i--) {
      const match = matched[i];
      if (match.meta?.roles) {
        return match.meta.roles.map(r => String(r).toUpperCase());
      }
    }
    return [];
  };

  const requiredRoles = getStrictestRoles(to.matched);
  const needLogin = to.meta?.needLogin;
  // 没有限制则直接放行
  if (!requiredRoles.length && !needLogin) {
    next();
    return;
  }


  // 异步获取用户信息并校验权限
  getUser().then(user => {
    const userRoles = (user?.roles || []).map(r => String(r).toUpperCase());

    // 检查用户是否拥有任一所需角色
    const hasPermission = !requiredRoles.length || requiredRoles.some(role => userRoles.includes(role));

    if (hasPermission) {
      next();
    } else {
      next({ name: 'noPermission', replace: true, query: {
        from: to.fullPath
      }});
    }
  }).catch((e) => {
    if (e?.code === 403) { // 未登录，会跳转登录页面，防止闪一下
      return;
    }
    // 获取用户失败时，视为无权限
    next({ name: 'noPermission', replace: true });
  });
})


router.afterEach((to, from) => {
  hubbleEntryEvent();
})

export default router;